export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isArray.js
// module id = 2227
// module chunks = 2